import deburr from 'lodash/deburr';

export enum MatchQuality {
  EXACT = 'exact',
  PARTIAL = 'partial',
  NONE = 'none',
}

export const getMatchQuality = (
  value: string,
  search: string
): MatchQuality => {
  const normalizedValue = deburr(value.toLowerCase().trim());
  const normalizedSearch = deburr(search.toLowerCase().trim());

  if (!normalizedValue.includes(normalizedSearch)) {
    return MatchQuality.NONE;
  }

  // Handle multi-word searches
  const searchWords = normalizedSearch
    .split(/\s+/)
    .filter((word) => word.length > 0);
  const valueWords = normalizedValue.split(/\s+/);

  if (searchWords.length === 1) {
    // Single word search - use fast exact match check
    const searchIndex = normalizedValue.indexOf(normalizedSearch);
    if (searchIndex !== -1) {
      const beforeChar =
        searchIndex === 0 ? ' ' : (normalizedValue[searchIndex - 1] ?? ' ');
      const afterIndex = searchIndex + normalizedSearch.length;
      const afterChar =
        afterIndex >= normalizedValue.length
          ? ' '
          : (normalizedValue[afterIndex] ?? ' ');

      const isWordBoundary = (char: string) => /[\s\W]/.test(char);
      if (isWordBoundary(beforeChar) && isWordBoundary(afterChar)) {
        return MatchQuality.EXACT;
      }
    }
    return MatchQuality.PARTIAL;
  }

  // Multi-word search: check if all search words exist as exact words in the value
  const allWordsExactMatch = searchWords.every((searchWord) =>
    valueWords.some((valueWord) => valueWord === searchWord)
  );

  if (allWordsExactMatch) {
    return MatchQuality.EXACT;
  }

  return MatchQuality.PARTIAL;
};

export const isFullMatch = (value: string, search: string): boolean =>
  deburr(value.toLowerCase().trim()) === deburr(search.toLowerCase().trim());
